import { cn } from './utils';

function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn('animate-pulse rounded-lg bg-muted', className)}
      aria-hidden
      {...props}
    />
  );
}

function SkeletonCard({ className }) {
  return (
    <div className={cn('rounded-xl border border-border/50 bg-card p-6 space-y-4', className)}>
      <Skeleton className="h-4 w-1/3" />
      <Skeleton className="h-8 w-2/3" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-4/5" />
    </div>
  );
}

export { Skeleton, SkeletonCard };
